import { Collection } from 'core/model/Collection';
import { observable } from 'mobx';
import type DeviceModel from 'app/stores/device/DeviceModel';
import { Model } from 'core/model/Model';
import { DeviceEventFields } from '@kentik/ui-shared/device/constants';
import { SimpleModel } from 'core/model/model.types';

type DeviceSyslogsModel = SimpleModel<keyof typeof DeviceEventFields>;

export class DeviceSyslogsCollection extends Collection<Model<DeviceSyslogsModel>> {
  @observable.ref
  device: DeviceModel;

  get model() {
    return Model<DeviceSyslogsModel>;
  }

  constructor(device: DeviceModel) {
    super();
    this.device = device;
    this.requestStatus = 'awaitingRequest';
  }

  get url() {
    return `/api/ui/devices/${this.device.id}/syslog/query`;
  }

  get fetchMethod() {
    return 'post' as const;
  }
}
